/**
 * The dialog state a fresh grant produces.
 *
 * Reach and scope are read off the GRANT the backend echoed, not off what was
 * requested: if it narrowed either, the dialog has to describe the link that
 * exists rather than the one that was asked for.
 *
 * `scope` falls back to the requested value when the response does not carry one.
 * Without that, a backend that does not echo it yet makes every non-default grant
 * read as "not what you asked for" forever — the dialog would sit on "Update
 * link", warn that the link is stale, and mint a new grant on every press. An
 * un-echoed scope is the one we asked for, as far as anything here can know.
 */
export const grantedShareState = (sessionId, data, requestedScope) => ({
  open: true,
  sessionId,
  status: 'ready',
  token: data?.token,
  expiresAt: data?.expires_at || null,
  isPublic: !!data?.public,
  scope: data?.scope || requestedScope,
});
